import React from 'react';
import classes from './GrayCardWithVerticalDivider.module.scss'

interface GrayCardWithVerticalDividerProps {
    title: string;
    text: string;
}

const GrayCardWithVerticalDivider:React.FC<GrayCardWithVerticalDividerProps> = ({title, text}) => {
    return (
        <div className={classes.card}>
            <div className={classes['title-container']}>
                <h5>{title}</h5>
            </div>
            <div className={classes.divider}></div>
            <span>{text}</span>
        </div>
    );
};

export default GrayCardWithVerticalDivider;